export default __webpack_public_path__ + "static/media/auth-background.021b9a14.jpg";